import { render, staticRenderFns } from "./bsqCgq.vue?vue&type=template&id=48d8bb75&scoped=true"
import script from "./bsqCgq.vue?vue&type=script&lang=js"
export * from "./bsqCgq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8bb75",
  null
  
)

export default component.exports